// jQuery wrapper
(function($) {

	/**
	 ** Document ready
	 **/
	$(document).ready(function(){

		$('body').addClass('active');


		// Header bar scrolled
		scrollbarState();


		// In-page menu triggers - Treatment
		if ( $('.mob-treatment-trigger').length > 0 ) {
			$('.mob-treatment-trigger').click( function() {
				$('body').addClass(' menu-open mob-menu-open');
				$('#site-header .hamburger').addClass('is-active');
				$('#mobile-menu').addClass('open');
				$('.mob-main').hide();
				$('#mobile-menu #treatments').addClass('show animated fadeIn');
			});
		}
		if ( $('.dt-treatment-trigger').length > 0 ) {
			$('.dt-treatment-trigger').on('click', function(event) {
				event.stopPropagation();
				$('.treatmentDropdown .dropdown-toggle').attr('aria-expanded',true).toggleClass('show');
				$('.treatmentDropdown .dropdown-menu').toggleClass('show');
			});
		}

		// In-page menu triggers - Treatment
		if ( $('.mob-concern-trigger').length > 0 ) {
			$('.mob-concern-trigger').click( function() {
				$('body').addClass(' menu-open mob-menu-open');
				$('#site-header .hamburger').addClass('is-active');
				$('#mobile-menu').addClass('open');
				$('.mob-main').hide();
				$('#mobile-menu #conditions').addClass('show animated fadeIn');
			});
		}
		if ( $('.dt-concern-trigger').length > 0 ) {
			$('.dt-concern-trigger').on('click', function(event) {
				event.stopPropagation();
				$('.concernDropdown .dropdown-toggle').attr('aria-expanded',true).toggleClass('show');
				$('.concernDropdown .dropdown-menu').toggleClass('show');
			});
		}




		// Mobile Menu - Hamburger
		$('.hamburger').click(function() {
			var target = $(this).data('target');

			if ( $('.hamburger').hasClass('is-active') ) {
				$('.hamburger').removeClass('is-active');

				$('.card .hasSub a').removeClass('active');
				$('.card .dropdown-toggle').removeClass('show');
				$('.card .dropdown-menu').removeClass('show');

				// $('.card .hasChild a').removeClass('active');
				$('.sub .card').removeClass('show animated fadeIn');
				$('.children .card').removeClass('show animated fadeIn');

				$('body').removeClass('menu-open mob-menu-open');
				$(target).removeClass('open');
				$('#mobile-menu-inner').scrollTop(0);

				$('.mob-main').show();

			} else {
				$('.hamburger').addClass('is-active');

				$('body').addClass('menu-open mob-menu-open');
				$(target).addClass('open');
				$('#mobile-menu-inner').scrollTop(0);
			}
		});

		// Mobile Menu - First Level
		$('.card .hasSub a').click(function(event) {
			event.preventDefault();

			var target = '#mobile-menu ' + $(this).attr('href');

			$('.children .card').removeClass('show animated fadeIn');
			// $('.card .hasChild a').removeClass('active');
			$('.card .hasSub a').not(this).removeClass('active');
			$('.mob-main').hide();
			
			$('.sub .card').removeClass('show animated fadeIn');

			if ($(this).hasClass('active')) {
				$(target).removeClass('show animated fadeIn');
				$(this).removeClass('active');
				// $('.card .hasChild a').removeClass('active');
			} else {
				$(target).addClass('show animated fadeIn');
				$(this).addClass('active');
			}		
		});

		$('.close-sub').click(function() {
			event.preventDefault();

			var target = '#mobile-menu ' + $(this).attr('href');
			$('.nav-link.active').removeClass('active');
			$(target).addClass('fadeOut');
			$(target).removeClass('fadeOut fadeIn show animated');

			$('.mob-main').show();
		});
		// Mobile Menu - Third Level
		$('.close-child').click(function() {
			event.preventDefault();
			var target = '#mobile-menu ' + $(this).attr('href');
			$('.sub .nav-link.active').removeClass('active');
			$(target).addClass('fadeOut');
			setTimeout(function(){
			  	$(target).removeClass('fadeOut fadeIn show animated');
			}, 1000);
		});


		// Smooth Scroll
		$('a.smooth-scroll, button.smooth-scroll').on('click', function(event) {
			event.preventDefault();
			var target = $(this).data('target');
			// var headerHeight = $('#site-header').outerHeight();
			// var scrollPosition = $(target).offset().top - headerHeight;
			var scrollPosition = $(target).offset().top;

			// console.log(headerHeight);

			$('html').animate({
	            scrollTop: scrollPosition
	        }, 1000);
		});


		// Accordion list (FAQs / Features)
		if ($('.accordion').length > 0) {
	        var allPanels = $('.accordion dd');

	        $('.accordion dt').click( function() {
	            var target = $(this).next();
	            var targetParent = $(this).parent().parent();

	            if ( $(target).hasClass('active') ) {
	                $(this).removeClass('current');
	                $(targetParent).removeClass('current-parent');
	                $(target).removeClass('active').slideUp(250);
	            } else {
	                $('.accordion dt').removeClass('current');
	                $(allPanels).removeClass('active').slideUp(250);
	                $('.accordion .item').removeClass('current-parent');
	                $(this).addClass('current');
	                $(targetParent).addClass('current-parent');
	                $(target).addClass('active').slideDown(250);
	            }
	            
	            // Prevent default 'link' behaviour
	            return false;
	        });
	    }


	    // Contact Page - Extra Content
	    if ($('.extra-info').length > 0) {
	    	var infoPanels = $('.extra-info .info-content').hide();

	    	$('.extra-info .btn').click( function() {
	    		var target = $(this).next();
	            var targetParent = $(this).parent().parent();

	            if ( $(target).hasClass('active') ) {
	                $(this).removeClass('current');
	                $(targetParent).removeClass('current-parent');
	                $(target).removeClass('active').slideUp(250);
	            } else {
	                $('.accordion dt').removeClass('current');
	                $(allPanels).removeClass('active').slideUp(250);
	                $('.accordion .item').removeClass('current-parent');
	                $(this).addClass('current');
	                $(targetParent).addClass('current-parent');
	                $(target).addClass('active').slideDown(250);
	            }
	            
	            // Prevent default 'link' behaviour
	            return false;
	        });
	    }


	    // News Post layout
	    if ($('.single-news').length > 0) {
	    	newsPostBackground();
	    }
	    // Filter toggle (news)
	    if ( $('#filter').length > 0 ) {
	    	$('.filter-toggle').click( function() {
	    		$(this).toggleClass('active');
	    		$('.mobile-filter').toggleClass('open');
	    	})
	    }
	    // Dropkick - custom dropdown/select
		if ( $('#filter') ) {
		    $('#filter select').dropkick({
		        mobile: true
		    });
		}


		// Forms
		// Dropkick - custom dropdown/select
		if ( $('.gform_wrapper select') ) {
		    $('.gform_wrapper select').dropkick({
		        mobile: true
		    });
		}


	    // Carousels
	    // Awards
	    if ( $('.awards-carousel').length > 0 ) {
	        $('.awards-carousel').slick({
				adaptiveHeight: false,
		    	arrows: true,
		    	dots: false,
	            fade: false,
		    	infinite: true,
	            slidesToShow: 4,
	            appendArrows: $('.awards-controls .slick-nav'),

	            responsive: [
		    		{
		    			breakpoint: 768,
		    			settings: {
		    				slidesToShow: 2,
		    			}
		    		},
		    		{
		    			breakpoint: 576,
		    			settings: {
		    				slidesToShow: 1,
		    			}
		    		},
		    	]
		  	});
	    }

	    // Reasons to Choose
	    if ( $('.reasons-carousel').length > 0 ) {
	        $('.reasons-carousel').slick({
				adaptiveHeight: false,
		    	arrows: true,
		    	dots: false,
	            fade: false,
		    	infinite: true,
	            slidesToShow: 4,
	            appendArrows: $('.reasons-controls .slick-nav'),

	            responsive: [
		    		{
		    			breakpoint: 768,
		    			settings: {
		    				slidesToShow: 2,
		    			}
		    		},
		    		{
		    			breakpoint: 576,
		    			settings: {
		    				slidesToShow: 1,
		    			}
		    		},
		    	]
		  	});
	    }

	    // Contact Page images
	    if ( $('.contact-img-carousel').length > 0 ) {
	        $('.contact-img-carousel').slick({
				adaptiveHeight: false,
		    	arrows: true,
		    	dots: false,
	            fade: false,
		    	infinite: true,
	            slidesToShow: 3,
	            appendArrows: $('.contact-img-controls .slick-nav'),

	            responsive: [
		    		{
		    			breakpoint: 768,
		    			settings: {
		    				slidesToShow: 2,
		    			}
		    		},
		    		{
		    			breakpoint: 576,
		    			settings: {
		    				slidesToShow: 1,
		    			}
		    		},
		    	]
		  	});
	    }

	    // As Seen In
	    if ( $('.seen-in-carousel').length > 0 ) {
	        $('.seen-in-carousel').slick({
				adaptiveHeight: false,
		    	arrows: true,
		    	dots: false,
	            fade: true,
		    	infinite: true,
	            slidesToShow: 1,
	            appendArrows: $('.seen-in-controls .slick-nav'),
		  	});
	    }


	    // Smile Gallery - Homepage
	    if ( $('.gallery-carousel').length > 0 ) {
	        $('.gallery-carousel').slick({
				adaptiveHeight: false,
		    	arrows: true,
		    	dots: false,
	            fade: false,
		    	infinite: true,
	            slidesToShow: 3,
	            appendArrows: $('.gallery-controls .slick-nav'),
		  	});

		  	$('.gallery-carousel-mob').slick({
				adaptiveHeight: false,
		    	arrows: true,
		    	dots: false,
	            fade: false,
		    	infinite: true,
	            slidesToShow: 1,
	            appendArrows: $('.gallery-mob-controls .slick-nav'),
		  	});
	    }

	    // Testimonial Carousel
	    if ( $('.testimonial-carousel').length > 0 ) {
	        $('.testimonial-carousel').slick({
				adaptiveHeight: false,
		    	arrows: true,
		    	dots: false,
	            fade: true,
		    	infinite: true,
	            slidesToShow: 1,
	            appendArrows: $('.testimonial-controls .slick-nav'),
		  	});
	    }

	    // Featured Treatments Carousel
	    if ( $('.treatment-carousel').length > 0 ) {
	        $('.treatment-carousel').slick({
				adaptiveHeight: false,
		    	arrows: true,
		    	dots: false,
	            fade: false,
		    	infinite: false,
	            slidesToShow: 2,
	            appendArrows: $('.treatment-controls .slick-nav')
		  	});

		  	$('.treatment-carousel-mob').slick({
				adaptiveHeight: false,
		    	arrows: true,
		    	dots: false,
	            fade: false,
		    	infinite: true,
	            slidesToShow: 1,
	            appendArrows: $('.treatment-mob-controls .slick-nav')
		  	});
	    }

	    // Featured Conditions Carousel
	    if ( $('.condition-carousel').length > 0 ) {
	        $('.condition-carousel').slick({
				adaptiveHeight: false,
		    	arrows: true,
		    	dots: false,
	            fade: false,
		    	infinite: false,
	            slidesToShow: 2,
	            appendArrows: $('.condition-controls .slick-nav')
		  	});

		  	$('.condition-carousel-mob').slick({
				adaptiveHeight: false,
		    	arrows: true,
		    	dots: false,
	            fade: false,
		    	infinite: true,
	            slidesToShow: 1,
	            appendArrows: $('.condition-mob-controls .slick-nav')
		  	});
	    }

	    // At a Glance carousel
	    if ( $('.glance-carousel').length > 0 ) {
	        $('.glance-carousel').slick({
				adaptiveHeight: false,
		    	arrows: true,
		    	dots: false,
	            fade: false,
		    	infinite: true,
	            slidesToShow: 2,
	            appendArrows: $('.glance-controls .slick-nav'),

	            responsive: [
		    		{
		    			breakpoint: 768,
		    			settings: {
		    				slidesToShow: 2,
		    			}
		    		},
		    		{
		    			breakpoint: 576,
		    			settings: {
		    				slidesToShow: 1,
		    			}
		    		},
		    	]
		  	});
	    }

	    // Before / After carousel
	    if ( $('.ba-carousel').length > 0 ) {
	        $('.ba-carousel').slick({
				adaptiveHeight: false,
		    	arrows: true,
		    	dots: false,
	            fade: false,
		    	infinite: true,
	            slidesToShow: 2,
	            appendArrows: $('.ba-controls .slick-nav'),

	            responsive: [
		    		{
		    			breakpoint: 992,
		    			settings: {
		    				slidesToShow: 1,
		    			}
		    		}
		    	]
		  	});
	    }


	    // Smile Gallery carousel (Smile Gallery page)
	    if ( $('.smile-gallery-carousel').length > 0 ) {
	        smileGalleryCarousels();
	    }
	    if ( $('.smile-video-carousel').length > 0 ) {
	    	smileVideoCarousels();
	    }

	    // Treatments - Video carousel with modals
	    if ( $('.single-treatment .video-carousel').length > 0 ) {
			// Videos
	        $('.video-carousel').slick({
				adaptiveHeight: false,
		    	arrows: true,
		    	dots: false,
	            fade: false,
		    	infinite: true,
	            slidesToShow: 1,	            
	            appendArrows: $('.video-controls .slick-nav'), 
		  	});
		}

		// Treatments - Video carousel with modals
	    if ( $('.page-patient-experience .video-carousel').length > 0 ) {
			// Videos
	        $('.video-carousel').slick({
				adaptiveHeight: false,
		    	arrows: true,
		    	dots: false,
	            fade: false,
		    	infinite: true,
	            slidesToShow: 2,            
	            appendArrows: $('.video-controls .slick-nav'), 

	            responsive: [
		    		{
		    			breakpoint: 992,
		    			settings: {
		    				slidesToShow: 1,
		    			}
		    		}
		    	]
		  	});
		}

		// Smile Gallery - Video carousel with modals
	    if ( $('.page-smile-gallery .video-carousel').length > 0 ) {
			// Videos
	        $('.video-carousel').slick({
				adaptiveHeight: false,
		    	arrows: true,
		    	dots: false,
	            fade: false,
		    	infinite: true,
	            slidesToShow: 2,            
	            appendArrows: $('.video-controls .slick-nav'), 

	            responsive: [
		    		{
		    			breakpoint: 992,
		    			settings: {
		    				slidesToShow: 1,
		    			}
		    		}
		    	]
		  	});
		}

		// Video modals
	    $('.video-toggle').click( function() {
	    	var target = $(this).data('target');
	    	$(target).modal('toggle');
	    });

    	// Video modal - Empty player on close	    
        $('.close-video').click( function() {
        	$('.video-container').empty();
        });



	    // Set Cookie function
        function createCookie(name, value, days) {
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                var expires = "; expires=" + date.toGMTString();
            } else var expires = "";
            document.cookie = escape(name) + "=" + escape(value) + expires + "; path=/";
        }
        // If #custom-overlay exists and customModal cookie not set, show modal
        if ( $('#custom-overlay') ) { 
	        // Privacy Policy Cookies   
	        function customModalCookie(){
	            // Check cookie 
	            if ($.cookie('customModal') != "accepted") {
	            	$('#custom-overlay').addClass('show'); 
	            	$('body').addClass('custom-cookie-unset');
	            }

	            if ( $('#custom-overlay').length > 0 ) {
	            	$('body').addClass('custom-modal-present')
	            }

	            //Assign cookie on click
	            $('#custom-overlay a, #custom-overlay button').on('click',function(){
	                createCookie("customModal", "accepted", 7); // Cookie expires in 7 days
	                $('body').removeClass('custom-modal-present');

	                // Close modal
	                $('#custom-overlay').hide();
	            });
	        }           
	        // Run cookie policy function
	        customModalCookie();

	        
	    }
	    /*
        // Privacy Policy Cookies   
        function cookiesPolicyBar(){
            // Check cookie 
            if ($.cookie('heatonPrivacy') != "accepted") $('#privacy-bar').fadeIn(); 

            //Assign cookie on click
            $('#privacy-bar a, #privacy-bar button').on('click',function(){
                createCookie("heatonPrivacy", "accepted", 90); // Cookie expires in 90 days
                $('#privacy-bar').fadeOut();
            });
        }           
        // Run cookie policy function
        cookiesPolicyBar();
        */


    }); // End Document Ready


    // On load
	$(window).on('load', function() {

		scrollbarState();

		// Midnight - Booking button
		// $('#booking-button').midnight();

	});


	// On Scroll
	$(window).on('scroll', function () {

		scrollbarState();

	});


	// On Resize
	$(window).on('resize', function () {

		if ($('.single-news').length > 0) {
			newsPostBackground();
		}

	});


	// Header bar scrolled
	function scrollbarState() {
    	var navHeight = ( $('#site-header').outerHeight() + 60 );

		if ( $(document).scrollTop() > navHeight ) {
			$('body').addClass('scrolled');
			$('#site-header').addClass('fixed');
		} else {
    		$('body').removeClass('scrolled fixed');
    		$('#site-header').removeClass('fixed');
		}
	}


	// News post background
	function newsPostBackground() {
		var postImageHeight = $('.post-image').outerHeight();
		// Set minimum height to header to give img space
		$('.post-header').css('min-height', (postImageHeight + 24) );

		var headerHeight = $('.post-content').offset();
		var offsetTop = headerHeight.top;
		// Set top of background to match bottom position of post header
		$('.content-bg').css('top', offsetTop);
	}


	// Multiple carousels withs same class
	function smileGalleryCarousels() {
        var smileGalleryCarousels = $(".smile-gallery-carousel:not(.slick-initialized)");
	    smileGalleryCarousels.each(function() {
	        $(this).slick({
				adaptiveHeight: false,
		    	arrows: true,
		    	dots: false,
	            fade: false,
		    	infinite: true,
	            slidesToShow: 2,
	            // appendArrows: $('.smile-gallery-controls .slick-nav'),

	            responsive: [
		    		{
		    			breakpoint: 992,
		    			settings: {
		    				slidesToShow: 1,
		    			}
		    		}
		    	]
		  	});
	    });
	}

	function smileVideoCarousels() {
        var smileVideoCarousels = $(".smile-video-carousel:not(.slick-initialized)");
	    smileVideoCarousels.each(function() {
	        $(this).slick({
				adaptiveHeight: false,
		    	arrows: true,
		    	dots: false,
	            fade: false,
		    	infinite: true,
	            slidesToShow: 2,
	            // appendArrows: $('.smile-gallery-controls .slick-nav'),

	            responsive: [
		    		{
		    			breakpoint: 992,
		    			settings: {
		    				slidesToShow: 1,
		    			}
		    		}
		    	]
		  	});
	    });
	}


	/*
	function linkTarget() {
		$('#footer-menu li').each( function() {
			if ( $(this).hasClass('new-window') ) {
				$(this).children('a').attr('target','_blank');
			}
		});
	}
	*/

	
// end jQuery wrapper
})(jQuery);

